module.exports = __webpack_public_path__ + "static/logo_HeroCs_d2_tab-068a9eaddd5d424b30b6b971f581aa38.png";